<template>
    <div class="score">
        <app-score-tile v-for="(point, index) in scoreArray" :key="index" :point="point" :smallFont="smallFont"></app-score-tile>
    </div>
</template>

<script>
import scoreTile from "./scoreTile.vue";

export default {
    name: "score",
    components: {
        AppScoreTile: scoreTile
    },
    props: {
        score: {
            type: Number,
            required: false
        },
        smallFont: {
            type:Boolean,
            default:false
        }
    },
    computed: {
        scoreArray() {
            var result = new Array();
            var scoreString = this.score.toString();
            if (scoreString.length == 1) {
                scoreString = "00" + scoreString;
            }
            if (scoreString.length == 2) {
                scoreString = "0" + scoreString;
            }
            result = Array.from(scoreString);
            return result;
        }
    }
};
</script>

<style scoped>
h1 {
    margin: 15% auto;
    font-size: calc(0.4em + 2.5vw);
}
@media only screen and (min-width: 1200px) {
    h1 {
        font-size: calc(0.25em + 1vw);
    }
}
.score {
    margin-top:2%;
    margin-right:2%;
    height: 80%;
    width:100%;
    float:right;
}
</style>
